import { useCurrentUser } from "@/api/current-user";
import { useLocale as useD3ChartLocale } from "@soft-db/d3-chart";
import { setLocale as formLocale } from "@soft-db/form";
import { useLocale as useSoftUILocale } from "@soft-db/ui";
import { computed, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

const localStorageKey = "preferredLang";

export function getCurrentLocale() {
	return localStorage.getItem(localStorageKey) || navigator.language;
}

export const provideLocale = () => {
	const localStorageLocale = localStorage.getItem(localStorageKey);

	const route = useRoute();

	const urlLocale = computed(() => {
		return route.query.lang as string | undefined;
	});

	const browserLocale = navigator.language;

	const { data: user } = useCurrentUser();

	const userLocale = computed(() => user.value?.preferredLang);

	const locale = computed(() => {
		if (userLocale.value) return userLocale.value;
		if (urlLocale.value) return urlLocale.value;
		if (localStorageLocale) return localStorageLocale;
		return browserLocale;
	});

	const i18n = useI18n();
	const softUILocale = useSoftUILocale();
	const d3ChartLocale = useD3ChartLocale();

	watchEffect(() => {
		i18n.locale.value = locale.value;

		const lang = locale.value.includes("fr") ? "fr" : "en";
		formLocale(lang);
		softUILocale.setLang(lang);
		d3ChartLocale.setLang(lang);
	});

	watchEffect(() => {
		if (userLocale.value) {
			localStorage.setItem(localStorageKey, userLocale.value);
		}
	});
};
